import React from "react";
import { ArrowUpRight, Mail, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import {
  BRAND, FX_DROPDOWN, NAV_ITEMS, SERVICES_DROPDOWN, dropdownItemPath,
  navItemPath, servicePath,
} from "../lib/constants";

const platformLinks = FX_DROPDOWN.flatMap((group) => group.items).slice(0, 6);
const serviceLinks = SERVICES_DROPDOWN.flatMap((group) => group.items).slice(0, 6);

export default function Footer() {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[#050B08] text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 sm:py-20">
        <div className="grid gap-12 border-b border-white/10 pb-16 lg:grid-cols-[1.35fr_.65fr_.65fr_.8fr]">
          <div>
            <img src={BRAND.logo} alt={BRAND.name} className="h-14 w-auto" />
            <h2 className="mt-8 max-w-lg font-display text-3xl font-bold leading-tight sm:text-4xl">
              Make your broker technology feel like one business.
            </h2>
            <Link to="/contact" className="mt-8 inline-flex items-center gap-2 border-b border-[#C8FF4D] pb-1 font-bold text-[#C8FF4D]">
              Start a conversation <ArrowUpRight className="h-4 w-4" />
            </Link>
          </div>

          <div>
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">Navigate</p>
            <ul className="space-y-3">
              {NAV_ITEMS.map((item) => (
                <li key={item.label}><Link to={navItemPath(item)} className="text-sm text-white/60 hover:text-white">{item.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">Platform</p>
            <ul className="space-y-3">
              {platformLinks.map((item) => (
                <li key={item.title}><Link to={dropdownItemPath(item)} className="text-sm text-white/60 hover:text-white">{item.title}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <p className="mb-5 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35">Digital services</p>
            <ul className="space-y-3">
              {serviceLinks.map((item) => (
                <li key={item.title}><Link to={servicePath(item.slug)} className="text-sm text-white/60 hover:text-white">{item.title}</Link></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="grid gap-8 pt-8 text-sm text-white/45 md:grid-cols-3">
          <a href={`mailto:${BRAND.email}`} className="flex items-center gap-3 hover:text-white">
            <Mail className="h-4 w-4 text-[#C8FF4D]" /> {BRAND.email}
          </a>
          <a href={`tel:${BRAND.phone.replace(/[\s()-]/g, "")}`} className="flex items-center gap-3 hover:text-white">
            <Phone className="h-4 w-4 text-[#C8FF4D]" /> {BRAND.phone}
          </a>
          <p className="md:text-right">© {new Date().getFullYear()} {BRAND.name}. Technology vendor only.</p>
        </div>
      </div>
      <div className="pointer-events-none absolute -bottom-24 right-0 font-display text-[13vw] font-bold leading-none text-white/[0.025]">
        FXBX
      </div>
    </footer>
  );
}
